<template>
  <transition name="fade">
    <div
      v-if="loading"
      ref="loadingWrapper"
      class="ic-loading-wrapper"
      :class="{ global: isGlobal }"
    >
      <div class="ic-loading-box">
        <div class="ic-loader1" />
        <div class="ic-loader2" />
      </div>
      <span v-if="title" class="ic-loading-title">{{ title }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    isGlobal: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
  },
  mounted() {
    if (!this.isGlobal && typeof this.$refs.loadingWrapper !== 'undefined') {
      const parent = this.$refs.loadingWrapper.parentNode
      parent.style.position = 'relative'
      parent.style.overflow = 'hidden'
    }
  },
}
</script>

<style lang="scss" src="./Loader.scss" />
